import "bootstrap/dist/css/bootstrap.css";
import App from "./components/App.vue";
import router from "./router.js";
import VueNotifications from "vue-notifications";
import VueApexCharts from "vue3-apexcharts";
import miniToastr from "mini-toastr";
import localization from "./localization/cz.json";
import localizationEN from "./localization/en.json";
import localizationDE from "./localization/de.json";
import { createI18n } from "vue-i18n";
import { createApp } from "vue";

const messages = {
    cz: localization,
    en: localizationEN,
    de: localizationDE
};

const i18n = createI18n({
    locale: document.documentElement.lang,
    fallbackLocale: 'en',
    messages
});

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](i18n.global.t(message), i18n.global.t(title), timeout, cb);
}
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}

const app = createApp(App);

app.use(i18n)
    .use(router)
    .use(VueNotifications, options)
    .use(VueApexCharts);

app.mount('#app');